"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterRequestPayloadToJSON = exports.RegisterRequestPayloadFromJSONTyped = exports.RegisterRequestPayloadFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function RegisterRequestPayloadFromJSON(json) {
    return RegisterRequestPayloadFromJSONTyped(json, false);
}
exports.RegisterRequestPayloadFromJSON = RegisterRequestPayloadFromJSON;
function RegisterRequestPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'gender': (0, _1.GenderFromJSON)(json['gender']),
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'dateOfBirth': (new Date(json['dateOfBirth'])),
        'emailAddress': json['emailAddress'],
        'password': !(0, runtime_1.exists)(json, 'password') ? undefined : json['password'],
        'city': json['city'],
        'zipCode': json['zipCode'],
        'street': json['street'],
        'houseNumber': json['houseNumber'],
        'additional': !(0, runtime_1.exists)(json, 'additional') ? undefined : json['additional'],
        'countryCode': !(0, runtime_1.exists)(json, 'countryCode') ? undefined : json['countryCode'],
        'primaryPhoneNumber': !(0, runtime_1.exists)(json, 'primaryPhoneNumber') ? undefined : json['primaryPhoneNumber'],
        'isGuestChecked': json['isGuestChecked'],
        'isTermsConditionsChecked': json['isTermsConditionsChecked'],
        'isNewsletterChecked': json['isNewsletterChecked'],
    };
}
exports.RegisterRequestPayloadFromJSONTyped = RegisterRequestPayloadFromJSONTyped;
function RegisterRequestPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'gender': (0, _1.GenderToJSON)(value.gender),
        'firstName': value.firstName,
        'lastName': value.lastName,
        'dateOfBirth': (value.dateOfBirth.toISOString().substr(0, 10)),
        'emailAddress': value.emailAddress,
        'password': value.password,
        'city': value.city,
        'zipCode': value.zipCode,
        'street': value.street,
        'houseNumber': value.houseNumber,
        'additional': value.additional,
        'countryCode': value.countryCode,
        'primaryPhoneNumber': value.primaryPhoneNumber,
        'isGuestChecked': value.isGuestChecked,
        'isTermsConditionsChecked': value.isTermsConditionsChecked,
        'isNewsletterChecked': value.isNewsletterChecked,
    };
}
exports.RegisterRequestPayloadToJSON = RegisterRequestPayloadToJSON;
//# sourceMappingURL=RegisterRequestPayload.js.map